import { render, staticRenderFns } from "./ManagerFeedList.vue?vue&type=template&id=2f62dd38&"
import script from "./ManagerFeedList.vue?vue&type=script&lang=js&"
export * from "./ManagerFeedList.vue?vue&type=script&lang=js&"
import style0 from "./ManagerFeedList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports